const heroImage =
  "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20wide%20shot%20of%20a%20dramatic%20entertainment%20news%20stage%2C%20warm%20crimson%20and%20amber%20spotlight%20beams%20converging%20through%20soft%20golden%20haze%2C%20floating%20translucent%20translucent%20speech%20bubbles%20and%20film%20light%20streaks%20rising%20upward%2C%20dark%20maroon%20vignette%20background%20with%20rich%20warm%20bokeh%2C%20absolutely%20no%20people%20or%20faces%2C%20stylized%20and%20artistic%20magazine%20cover%20atmosphere%2C%20high%20contrast%20premium%20lighting%2C%20elegant%20and%20moody%2C%20entertainment%20portal%20hero&width=1600&height=900&seq=hero-99chigua-2026&orientation=landscape";

const topRank = [
  { rank: 1, title: "决赛夜后台花絮持续刷屏", heat: "986.2万" },
  { rank: 2, title: "男团巡演加场疑似官宣预热", heat: "874.5万" },
  { rank: 3, title: "真人秀“剧本”争议回应发酵", heat: "763.1万" },
  { rank: 4, title: "探店博主翻车品牌解约", heat: "668.8万" },
  { rank: 5, title: "《春分辞》路透双热搜", heat: "612.3万" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="relative h-[600px] w-full md:h-[620px]">
        <img
          src={heroImage}
          alt="99吃瓜 实时更新的今日瓜点与热门事件封面"
          title="99吃瓜 今日瓜点与最新爆料"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-primary-900/55 to-background-950/90" />

        <div className="relative z-10 mx-auto flex h-full w-full max-w-[1320px] flex-col items-center justify-center px-4 text-center md:px-6">
          <span className="mb-5 flex items-center gap-2 rounded-full border border-accent-300/50 bg-accent-400/15 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-100">
            <i className="ri-fire-line h-4 w-4 flex items-center justify-center text-accent-300" />
            今日瓜点 · 实时候速 · 全网热聊中
          </span>
          <h1 className="font-display text-4xl font-bold leading-tight text-background-50 md:text-6xl">
            一手热瓜，<span className="text-accent-300">点开就看明白</span>
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-primary-100/90 md:text-base">
            99吃瓜 把散落在各平台的今日瓜点、最新爆料与热门事件
            重新核实并梳理成清晰的时间线与前因后果。不用在各大平台手动翻，
            今天的热瓜、猛料，这里按时间排好了等你。
          </p>
          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
            <a
              href="#today"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
            >
              看今日瓜点
              <i className="ri-arrow-down-line h-4 w-4 flex items-center justify-center" />
            </a>
            <a
              href="#trend"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200/70 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              <i className="ri-arrow-up-line h-4 w-4 flex items-center justify-center text-accent-300" />
              围观热榜
            </a>
          </div>

          <div className="mt-9 flex items-center gap-6 text-background-50 sm:gap-10">
            <div>
              <p className="font-display text-2xl font-bold text-accent-300">128+</p>
              <p className="mt-1 text-xs text-primary-100/80">今日更新条数</p>
            </div>
            <span className="h-8 w-px bg-primary-500/50" />
            <div>
              <p className="font-display text-2xl font-bold text-accent-300">2.3万</p>
              <p className="mt-1 text-xs text-primary-100/80">当前在线吃瓜</p>
            </div>
            <span className="h-8 w-px bg-primary-500/50" />
            <div>
              <p className="font-display text-2xl font-bold text-accent-300">3200+</p>
              <p className="mt-1 text-xs text-primary-100/80">累计收录话题</p>
            </div>
          </div>
        </div>
      </div>

      {/* 实时热搜悬浮卡 */}
      <div className="relative z-20 mx-auto -mt-24 hidden w-full max-w-[1320px] px-4 md:block md:px-6">
        <div className="animate-rise overflow-hidden rounded-xl border border-background-200 bg-background-50 shadow-soft">
          <div className="flex items-center justify-between border-b border-background-200 px-5 py-3">
            <span className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
              <i className="ri-fire-fill h-4 w-4 flex items-center justify-center text-accent-500" />
              此刻热榜 · 正在发酵
            </span>
            <span className="flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-loader-4-line h-4 w-4 flex items-center justify-center animate-spin" />
              每 5 分钟更新
            </span>
          </div>
          <div className="grid grid-cols-5 divide-x divide-background-200">
            {topRank.map((t) => (
              <a
                key={t.rank}
                href="#trend"
                className="group px-4 py-4 transition-colors hover:bg-primary-50/60"
              >
                <p className="text-lg font-bold text-primary-600">{t.rank}</p>
                <p className="mt-1.5 line-clamp-2 min-h-[2.6rem] text-sm font-medium leading-snug text-foreground-800 group-hover:text-primary-700">
                  {t.title}
                </p>
                <p className="mt-2 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-fire-line h-3 w-3 flex items-center justify-center text-accent-500" />
                  {t.heat}
                </p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}